export const SORT_DEFAULT_LABEL = 'Best Match';
export const SORT_DEFAULT_LABEL_SEARCH = 'Relevancy';
